import { render, staticRenderFns } from "./widgets-list.vue?vue&type=template&id=4536370a&"
import script from "./widgets-list.vue?vue&type=script&lang=js&"
export * from "./widgets-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports